export default __webpack_public_path__ + "226aeec3e14b46186ee1722eaefe443d.png";